export default [
  {
    name: "fbLike",
    title: "Facebook Likes",
  },
  {
    name: "fbShare",
    title: "Facebook Shares",
  },
  {
    name: "instagramFollow",
    title: "Instagram Follows",
  },
  {
    name: "instagramVisit",
    title: "Instagram Visits",
  },
  {
    name: "youtubeSubscribe",
    title: "YouTube Subscribes",
  },
  {
    name: "youtubeWatch",
    title: "YouTube Views",
  },
  {
    name: "pinterestFollow",
    title: "Pinterest Follows",
  },
  {
    name: "pinterestPin",
    title: "Pinterest Pins",
  },
  {
    name: "snapchatFollow",
    title: "Snapchat Follows",
  },
  {
    name: "appDownload",
    title: "App Downloads",
  },

  // New social platforms
  {
    name: "xShare",
    title: "X Share",
  },
  {
    name: "xFollow",
    title: "X Follows",
  },
  {
    name: "tiktokFollow",
    title: "TikTok Follows",
  },
  {
    name: "tiktokShare",
    title: "TikTok Shares",
  },
  {
    name: "linkedinFollow",
    title: "LinkedIn Follows",
  },
  {
    name: "whatsappShare",
    title: "WhatsApp Shares",
  },
  {
    name: "discordJoin",
    title: "Discord Joins",
  },
  {
    name: "twitchFollow",
    title: "Twitch Follows",
  },
  {
    name: "threadsFollow",
    title: "Threads Follows",
  },
];
